import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from "./Media";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: [
      "Full Stack Developer.",
      "Backend Engineer.",
      "NestJS · Node.js Developer.",
      "Software Engineer.",
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className="text-sm font-mono uppercase tracking-[0.25em] text-cyan-400/80">
          Full Stack Developer · 2+ Years
        </h4>
        <h1 className="text-3xl md:text-4xl font-bold text-white">
          Hi, I'm{" "}
          <span className="heading-gradient capitalize">
            Tarigopula Chandra Mouli
          </span>
        </h1>
        <h2 className="text-2xl font-bold text-slate-100">
          a <span className="text-cyan-300">{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#00F0FF"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide text-slate-400">
          Full Stack Developer with 2+ years building enterprise web apps across
          fintech, sports betting, and legal-tech. Strong in React.js, NestJS,
          TypeScript, Node.js, PostgreSQL, and AWS — with proven API
          performance gains up to 25% and real-time systems under 200ms latency.
        </p>
        <p className="text-sm font-mono text-slate-500 tracking-wide">
          React.js · Node.js · NestJS · TypeScript · PostgreSQL · AWS
        </p>
      </div>
      <Media />
    </div>
  );
};

export default LeftBanner;
